import TimelineEntryItem from './timeline_entry_item.vue';
export default {
    name: 'PlaceholderSystemNote',
    components: {
        TimelineEntryItem
    },
    props: {
        note: {
            type: Object,
            required: true
        }
    }
};
